import React, { createContext, useContext, useState, useCallback } from 'react';
import en from './en';
import zhCN from './zh-CN';

const dictionaries = { en, 'zh-CN': zhCN };

const I18nContext = createContext();

const STORAGE_KEY = 'flashsync_lang';

function getInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && dictionaries[stored]) return stored;
  } catch (e) { /* ignore */ }
  return 'en';
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((l) => {
    if (dictionaries[l]) {
      setLangState(l);
      try { localStorage.setItem(STORAGE_KEY, l); } catch (e) { /* ignore */ }
    }
  }, []);

  const t = useCallback((key, params) => {
    const dict = dictionaries[lang] || dictionaries.en;
    let str = dict[key] || dictionaries.en[key] || key;
    if (params) {
      Object.keys(params).forEach(k => {
        str = str.replace(`{${k}}`, params[k]);
      });
    }
    return str;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useT must be used within I18nProvider');
  return ctx;
}

export default I18nContext;
